module.exports = __webpack_public_path__ + "img/far-filter.2ea547c6.svg";